<template>
    <div class="warpper padding-sm">
        <div class="flex align-center justify-between margin-bottom-sm list-title">
            <b> 级别管理</b>
            <span class="add-btn" @click="levelDialog = true" v-if="user.isBranch"
            >级别添加
            </span>
        </div>
        <div class="ship-list">
            <el-table :data="levelList" header-row-class-name="table-header"
                      border
                      style="width: 100%; border-radius: 10px">
                <el-table-column label="会员身份" prop="name">
                    <template slot-scope="scope">
                       <div class="flex justify-center"> {{scope.row.name}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="会费（元）" prop="price">
                    <template slot-scope="scope">
                        <div class="flex justify-center">{{scope.row.price}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" v-if="user.isBranch">
                    <template slot-scope="scope">
                        <div class="flex justify-center">
                        <el-button @click="editItem(scope.row)" class="blue-btn"  round size="small">编辑</el-button>
                        <span class="padding-lr-sm" v-if="scope.$index>2"></span>
                        <el-button @click="delItem(scope.row.id)" class="line-btn" round size="small" v-if="scope.$index>2">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <level-dialog
            :setItem="setItem"
            :levelDialog="levelDialog"
            @cancelDialog="cancelDialog"
        />
    </div>
</template>

<script>
import {getRankList, delRank} from "@/api/branch";
import LevelDialog from "./dialog/levelDialog";

export default {
    name: "level",
    data() {
        return {
            levelList: [],
            setItem:null,
            levelDialog:false

        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        this.$emit('setIndex', [2, 0], '级别设置')
        this.getRankList()
    },
    components: {LevelDialog},
    methods: {
        //  关闭编辑框
        cancelDialog(val){
            this.setItem = null
            this.levelDialog = false
            if(val){
                this.getRankList()
            }
        },
        //  编辑
        editItem(obj){
            this.setItem = obj
            this.levelDialog = true
        },
        //    删除级别
        delItem(id) {
            this.$confirm('此操作将删除该级别, 是否继续?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.sureDelete(id)
            })
        },
        async sureDelete(id) {
            let _state = await delRank(id)
            if (_state.status === 200) this.$message.success(_state.msg), this.getRankList()
        },
        //  获取等级列表
        async getRankList() {
            let _list = await getRankList()
            this.levelList = _list.data
        }
    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss">
.warpper {
    background: #fff;
    border-radius: 10px;

    .list-title {
        b {
            font-size: 26px;
            line-height: 34px;
        }

        .add-btn {
            display: block;
            width: 200px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
            linear-gradient(#0a2240, #0a2240);
            background-blend-mode: normal, normal;
            border-radius: 20px;
            font-size: 16px;
            color: #fff;
            cursor: pointer;
        }
    }
}
</style>